import React, {CSSProperties, useEffect, useState} from "react";

export type TZeeroButton = {
	id?: string;
	type: ZeeroButtonType;
	size?: ZeeroButtonSize;
	style?: CSSProperties;
	enabled?: boolean;
	check?: boolean;
	activeState?: boolean;
	onClick: (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
	className?: string;
	children?: any;
};

export type ZeeroButtonType =
		| "primary"
		| "secondary"
		| "secondary-outline"
		| "warn"
		| "danger"
		| "none"
		| "table-action";
export type ZeeroButtonSize = "xs" | "sm" | "md" | "lg" | "xl";

const ZeeroButton = ({
  id,
  type,
  size,
  style,
  enabled = true,
  check = false,
  activeState = false,
  onClick,
  className = "",
  children,
}: TZeeroButton): React.ReactElement => {
	const [active, setIsActive] = useState<boolean>(activeState);

	useEffect(() => {
		setIsActive(activeState);
	}, [activeState]);

	return (
			<div
					id={id}
					className={`zeero-button ${type} ${size || ""} ${className} ${enabled == false ? " disabled" : ""} ${
							check && active ? " active" : ""
					}`}
					style={style}
					onClick={(evt) => {
						if (enabled) {
							if (check) {
								setIsActive(!active);
							}
							onClick(evt);
						}
					}}
			>
				<div className="zeero-button-content">{children}</div>
			</div>
	);
};

export default ZeeroButton;
